'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'status', 'pStatuses',
    function ($scope, $modalInstance, status, pStatuses) {

        $scope.ok = ok;
        $scope.cancel = cancel;

        init();

        // region Function

        function init() {
            $scope.dateFormat = 'dd.MM.yyyy';
            $scope.status = angular.copy(status);
            $scope.status.comment = '';
            $scope.projectStatuses = angular.copy(pStatuses);
        }

        function ok() {
            $modalInstance.close($scope.status);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        // endregion

    }];